import { BufferTrackerReact as BufferTracker } from '@buffer-mono/tracking-plan'

import { useAccount } from '~publish/contexts/AccountContext'

import {
  createEventTrackingData,
  getCoreTrackingMetadata,
} from './trackingHelpers'
import type {
  CallbackMethods,
  CTAPayload,
  UpgradePathPayload,
  ChannelCTAPayload,
} from './trackingTypes'

export const useTracking = (): CallbackMethods => {
  const { account } = useAccount()

  const metadataAccount = getCoreTrackingMetadata(account)
  const commonTrackingProperties =
    account?.currentOrganization?.commonTrackingProperties || null
  const trackingMetadata = metadataAccount.organizationId
    ? { ...metadataAccount, organizationId: metadataAccount.organizationId }
    : null

  /* CTAs EVENTS */
  const trackUpgradePathViewed = (payload: UpgradePathPayload): void => {
    if (!trackingMetadata) return
    BufferTracker.upgradePathViewed(
      createEventTrackingData(
        trackingMetadata,
        commonTrackingProperties,
        payload,
      ),
    )
  }
  const trackCTAClicked = (payload: CTAPayload): void => {
    if (!trackingMetadata) return
    BufferTracker.cTAClicked(
      createEventTrackingData(
        trackingMetadata,
        commonTrackingProperties,
        payload,
      ),
    )
  }

  /* CHANNELS EVENTS */
  const trackChannelCTAViewed = (payload: ChannelCTAPayload): void => {
    if (!trackingMetadata) return
    BufferTracker.channelCTAViewed(
      createEventTrackingData(trackingMetadata, commonTrackingProperties, {
        ...payload,
        upgradePathName: null,
      }),
    )
  }
  const trackChannelCTAClicked = (payload: ChannelCTAPayload): void => {
    if (!trackingMetadata) return
    BufferTracker.channelCTAClicked(
      createEventTrackingData(trackingMetadata, commonTrackingProperties, {
        ...payload,
        upgradePathName: null,
      }),
    )
  }

  return {
    trackUpgradePathViewed,
    trackCTAClicked,
    trackChannelCTAViewed,
    trackChannelCTAClicked,
  }
}
